export default "__VITE_ASSET__CDHAH$1y__"